import { createSlice } from "@reduxjs/toolkit";
import {
  fetchHotelContact,
  fetchOneContact,
  createHotelContact,
} from "./contactThunks";

const initialState = {
  data: [],
  oneData: null,
  totalPages: 1,
  totalItems: 0,
  loading: false,
  error: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel Status wise
      .addCase(fetchHotelContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHotelContact.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchHotelContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOneContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOneContact.fulfilled, (state, action) => {
        state.loading = false;
        state.oneData = action.payload;
      })
      .addCase(fetchOneContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createHotelContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(createHotelContact.fulfilled, (state, action) => {
        state.loading = false;
        state.oneData = action.payload;
      })
      .addCase(createHotelContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactSlice.reducer;
